var map = {
	"./BookShareHub.png": 1351,
	"./GWH.png": 9017,
	"./Git.png": 9939,
	"./Logo.png": 6148,
	"./ageverifypro.png": 9066,
	"./email.png": 3005,
	"./gitt.png": 103,
	"./google.png": 2553,
	"./light.png": 6102,
	"./map.png": 1377,
	"./meta.png": 9377,
	"./moon.png": 9585,
	"./nyiWebflow.png": 2043,
	"./phone.png": 9156,
	"./twitter.png": 3220,
	"./weatherapp.png": 8081,
	"./webflow.png": 6960,
	"./webfloww.png": 8632,
	"./youtube.png": 9844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;